import { KatIcon } from '@amzn/katal-react';
import { TFunction } from 'i18next';
import PinIcon from 'public/images/icons/pin.svg';

export enum MenuTypes {
  copy = 'copy',
  copySuccess = 'copySuccess',
  flag = 'flag',
  edit = 'edit',
  delete = 'delete',
  markSolution = 'markSolution',
  unmarkSolution = 'unmarkSolution',
  pin = 'pin',
}

const getAllMenuOptions = (t: TFunction) => ({
  [MenuTypes.copySuccess]: (
    <div className="bg-kat-fiji py-2.5 text-center text-white">
      <span>{t('menuOption_copySuccess')}</span>
    </div>
  ),
  [MenuTypes.copy]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <KatIcon className="ltr:mr-1.5 rtl:ml-1.5" size="tiny" name="link" />
      <span>{t('menuOption_copy')}</span>
    </div>
  ),
  [MenuTypes.flag]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <KatIcon className="text-kat-blood-orange ltr:mr-1.5 rtl:ml-1.5" size="tiny" name="flag" />
      <span>{t('menuOption_flag')}</span>
    </div>
  ),
  [MenuTypes.edit]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <KatIcon className="ltr:mr-1.5 rtl:ml-1.5" size="tiny" name="edit" />
      <span>{t('menuOption_edit')}</span>
    </div>
  ),
  [MenuTypes.delete]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <KatIcon className="ltr:mr-1.5 rtl:ml-1.5" size="tiny" name="delete" />
      <span>{t('menuOption_delete')}</span>
    </div>
  ),
  [MenuTypes.markSolution]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <KatIcon className="ltr:mr-1.5 rtl:ml-1.5" size="tiny" name="check_circle" />
      <span>{t('menuOption_markSolution')}</span>
    </div>
  ),
  [MenuTypes.unmarkSolution]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <KatIcon className="ltr:mr-1.5 rtl:ml-1.5" size="tiny" name="cancel" />
      <span>{t('menuOption_unmarkSolution')}</span>
    </div>
  ),
  [MenuTypes.pin]: (
    <div className="border-solid border-transparent py-1.5 px-2 hover:border-kat-eastern">
      <img src={PinIcon.src} alt="menuOption_pin" className="ltr:mr-1.5 rtl:ml-1.5" width={14} height={14} data-testid="pin-menu-option" />
      <span>{t('menuOption_pin')}</span>
    </div>
  ),

});
export default getAllMenuOptions;
